import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-forgot-password-skeleton',
  templateUrl: './forgot-password-skeleton.component.html',
  styleUrls: ['./forgot-password-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordSkeletonComponent {}
